import React from "react";

const whyChooseUsData = [
    {
        icon: "/images/about/w3.png",
        iconWidth: 30,
        title: "Best Price Guarantee",
        description:
            "Find the same tour cheaper elsewhere and we will match it — no questions asked. We believe great experiences should not have to break the bank. Our rates include hotel pickup, all activity equipment, and complimentary travel insurance — no surprise fees at checkout.",
    },
    {
        icon: "/images/about/w1.png",
        iconWidth: 30,
        title: "5-Star Rated Guides",
        description:
            "Our guides Rashid, Taj, and Waqas are not just drivers — they are storytellers, photographers and local experts. They know Dubai's desert and city inside out and love sharing it with you. Mentioned by name across 60+ five-star TripAdvisor reviews.",
    },
    {
        icon: "/images/about/w5.png",
        iconWidth: 30,
        title: "Free Hotel Pickup & Drop-Off",
        description:
            "We collect you from the lobby of your Dubai hotel in a clean, air-conditioned 4×4 vehicle and drop you back when your tour is done. No taxis, no coordination, no stress. Pickup available from any hotel, residence, Dubai Airport, or Dubai Cruise Terminal.",
    },
    {
        icon: "/images/about/w2.png",
        iconWidth: 30,
        title: "Complimentary Travel Insurance",
        description:
            "Every Bonvoy Tourism booking includes free travel insurance for all tour participants — automatically included at no extra charge. Complete peace of mind from the moment you confirm your booking to the moment you are safely dropped back at your hotel.",
    },
    {
        icon: "/images/about/w6.png",
        iconWidth: 30,
        title: "24/7 Customer Support",
        description:
            "Got a question at midnight before your 6 AM safari? No problem. Our team is available around the clock on +971-55-9215470 via phone and WhatsApp. We typically respond within minutes — any hour, any day, including public holidays.",
    },
    {
        icon: "/images/about/w7.png",
        iconWidth: 30,
        title: "Flexible Cancellation",
        description:
            "Plans change — we understand. Cancel any Bonvoy Tourism booking up to 24 hours before your tour departure time for a full refund, no questions asked. Rescheduling to a different date is also available free of charge with 24 hours notice.",
    },
];

export default function WhyChooseUsCTR() {
    return (
        <div className="mt-12 md:mt-22">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-4">
                Why Thousands of Travellers Choose Bonvoy Tourism
            </h3>

            <p className="text-[#4E4E4E] md:text-[18px] md:leading-relaxed mb-8 max-w-[730px]">
                There are dozens of tour operators in Dubai. Here is why our guests keep coming back — and why they always recommend us to their friends.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {whyChooseUsData.map((item, index) => (
                    <div
                        key={index}
                        className="shadow-md rounded-md p-5 bg-[#f9f9f9]"
                    >
                        <div className=" h-full">
                            <div className="flex flex-col justify-between h-full min-h-[200px]">
                                <div className="flex items-center">
                                    <div className="bg-white p-3 shadow-md rounded-md">
                                        <img
                                            src={item.icon}
                                            alt={item.title}
                                            width={item.iconWidth}
                                            height={item.iconWidth}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <p className="text-[15px] font-semibold text-[#4E4E4E] max-w-[730px] mb-2">
                                        {item.title}
                                    </p>

                                    <p className="text-[13px] font-medium text-[#606060] max-w-[730px]">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}